
<div class="right-side p-5">
  <!--<div style="text-align:right">Hello {{name}}</div>-->
  <h2>Profile</h2>
  <form [formGroup]="form">

    <div class="section">
      <!--<div class="card-title">
        <h1>Profile</h1>

      </div>
      <hr>-->
      <div class="card mb-3">
        <div class="card-header"> <h2>Personal Details</h2></div>
        <div class="card-body">
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <label class="nowrap">Registration ID<span class="text-danger">*</span></label>
              <input type="text" autocomplete="off" formControlName="registrationId" class="form-control" name="registrationId">
            </div>

            <!--<div class="mb-3">
              <label class="text-dark">Name Of Organisation</label>
              <input type="text" class="form-control" [value]="NameOfOrganisation" />


            </div>-->
            <div class="col-md-3 mb-2">
              <label class="nowrap">Name Of Organisation<span class="text-danger">*</span></label>
              <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="nameOfOrganisation" trimValue id="nameOfOrganisation" class="form-control"
                     name="nameOfOrganisation" placeholder="Name Of Organisation">
              <div *ngIf="f1['nameOfOrganisation'].touched && f1['nameOfOrganisation'].invalid" class="alert alert-danger required">
                <div *ngIf="f1['nameOfOrganisation'].errors && f1['nameOfOrganisation'].errors['required']">
                  Organization Name is required
                </div>
                <div *ngIf="f1['nameOfOrganisation'].errors && f1['nameOfOrganisation'].errors['minlength']">
                  Minimum length should be 3 characters
                </div>
                <div *ngIf="f1['nameOfOrganisation'].errors && f1['nameOfOrganisation'].errors['pattern']">
                  Enter characters only
                </div>
              </div>
            </div>


            <!--<div class="mb-3">
              <label class="text-dark">Address Of Organisation</label>
              <input type="text" class="form-control" [value]="AddressOfOrganisation" />

            </div>-->
            <div class="col-md-3 mb-2">
              <label class="nowrap">Address Of Organisation<span class="text-danger">*</span></label>
              <!--<input type="text"  autocomplete="off" formControlName="addressOfOrganisation" trimValue id="addressOfOrganisation" class="form-control"
                     name="addressOfOrganisation" placeholder="Address Of Organisation" maxlength="300">
              <div *ngIf="f1['addressOfOrganisation'].touched && f1['addressOfOrganisation'].invalid" class="alert alert-danger required">
                <div *ngIf="f1['addressOfOrganisation'].errors && f1['addressOfOrganisation'].errors['required']">
                  Address is required.
                </div>
                <div *ngIf="f1['addressOfOrganisation'].errors && f1['addressOfOrganisation'].errors['minlength']">
                  Minimum length should be 3 characters
                </div>
                <div *ngIf="f1['addressOfOrganisation'].errors && f1['addressOfOrganisation'].errors['maxlength']">
                  Maximum length should be 300 characters
                </div>
                <div *ngIf="f1['addressOfOrganisation'].errors && f1['addressOfOrganisation'].errors['pattern']">
                  Address must not contain '&' character and should not start with "&#64;+-=".
                </div>
              </div>-->

              <input type="text" autocomplete="off" formControlName="addressOfOrganisation" trimValue id="addressOfOrganisation" class="form-control"
                     name="addressOfOrganisation" placeholder="Address Of Organisation/Association" maxlength="300">
              <div *ngIf="f1['addressOfOrganisation'].touched && f1['addressOfOrganisation'].invalid">
                <div *ngIf="f1['addressOfOrganisation'].errors?.['required']" class="alert alert-danger">
                  Address is required.
                </div>
                <div *ngIf="f1['addressOfOrganisation'].errors?.['pattern']" class="alert alert-danger">
                  Address must not contain '&' character and should not start with "&#64;+-=".
                </div>
                <div *ngIf="f1['addressOfOrganisation'].errors?.['minlength']" class="alert alert-danger">
                  Address must be at least 3 characters long.
                </div>
                <div *ngIf="f1['addressOfOrganisation'].errors?.['maxlength']" class="alert alert-danger">
                  Address cannot exceed 300 characters.
                </div>
              </div>
            </div>






            <div class="col-md-3 mb-2">
              <label class="text-dark">User Name</label>
              <input type="text" class="form-control" formControlName="iaUserName" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3 mb-2">
              <label class="text-dark">Email</label>
              <input type="text" class="form-control" formControlName="email" />
            </div>

            <div class="col-md-3 mb-2">
              <label class="nowrap">Contact Number(Landline Number)</label>
              <input type="text" (keypress)="numberanddashOnly($event)" autocomplete="off" formControlName="contactNumber" (input)="formatContactNumber($event)" id="txtContactNumber" class="form-control"
                     name="contactNumber" placeholder="Contact Number" maxlength="13">
              <div *ngIf="f1['contactNumber'].touched && f1['contactNumber'].invalid" class="alert alert-danger required">

                <div *ngIf="f1['contactNumber'].errors?.['pattern']" class="alert alert-danger">
                  Please enter a valid contact number in the format XXX-XXX-XXXX.Maximum length should be 11 digits
                </div>
                <div *ngIf="f1['contactNumber'].errors && f1['contactNumber'].errors['maxlength']" class="alert alert-danger required">
                  Maximum length should be 12 digits
                </div>
              </div>
            </div>

            <div class="col-md-3 mb-2">
              <label class="text-dark">Mobile Number<span class="text-danger">*</span></label>
              <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="mobileNumber" maxlength="10">
              <div *ngIf="f1['mobileNumber'].touched && f1['mobileNumber'].invalid" class="alert alert-danger required">
                <div *ngIf="f1['mobileNumber'].errors && f1['mobileNumber'].errors['required']">
                  Mobile Number is required
                </div>
                <div *ngIf="f1['mobileNumber'].errors && f1['mobileNumber'].errors['minlength']">
                  Minimum length should be 10 characters
                </div>
                <div *ngIf="f1['mobileNumber'].errors && f1['mobileNumber'].errors['pattern']">
                  Enter numbers only
                </div>
              </div>
            </div>

            <!--<div class="col-md-3 mb-2">
                <label class="text-dark">Focus Sectors</label>
                <textarea class="form-control" formControlName="focusSectorName1"></textarea>
            </div>-->

          </div>
          <div class="col-md-12" *ngIf="!isMssidc">
            <div class="alert alert-success">
              <label class="nowrap">Focus Sector (You can choose multiple options)<span class="text-danger">*</span></label>
            </div>
          </div>
          <!--<div *ngIf="focusSector.length > 0">

          </div>-->
          <!--<div *ngFor="let focussector of focusSector">
            <label>
              <input type="checkbox"
                     [checked]="focussector.isChecked"
                     [value]="focussector.focusSectorId"
                     [name]="focussector.focusSectorName"
                     (change)="onFocusSectorChange($event)" />

              {{ focussector.focusSectorName}}


            </label>
          </div>-->
          <!--<div *ngIf="focusSector.length > 0">
            <div *ngFor="let focussector of focusSector">
              <label>
                <input type="checkbox"
                       [value]="focussector.focusSectorId"
                       [name]="focussector.focusSectorName"
                       [checked]="focussector.isChecked"
                (change)="onFocusSectorChange($event)" />
                {{ focussector.focusSectorName }}
              </label>
            </div>
          </div>-->
          <div *ngIf="!isMssidc">
            <div *ngFor="let focussector of focusSector">
              <label>
                <input type="checkbox"
                       [checked]="focussector.isChecked"
                       [value]="focussector.focusSectorId"
                       (change)="onFocusSectorChange($event, focussector.focusSectorId, focussector.focusSectorName)" />
                {{ focussector.focusSectorName }}
              </label>
            </div>
          </div>

          <div *ngIf="isMssidc">
            <div class="alert alert-success">
              <label class="nowrap">Focus Sector selected by IA<span class="text-danger">*</span></label>
            </div>
            <div *ngFor="let focussector of focusSector">
              <li *ngIf="focussector.isChecked">{{ focussector.focusSectorName }}</li>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"><h2>SPOC Details</h2></div>
        <div class="card-body">
          <div class="row mb-3" *ngIf="!isMssidc">
            <div class="col-md-3 mb-3">
              <label class="nowrap">Spoc Name<span class="text-danger">*</span></label>
              <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" id="txtSpocName" class="form-control"
                     formControlName="SpocName" trimValue placeholder="Enter Spoc Name" maxlength="50">
              <div *ngIf="f1['SpocName'].touched && f1['SpocName'].invalid">
                <div *ngIf="f1['SpocName'].errors && f1['SpocName'].errors['required']" class="alert alert-danger required">
                  Spoc Name is requried
                </div>
                <div *ngIf="f1['SpocName'].errors && f1['SpocName'].errors['minlength']" class="alert alert-danger required">
                  Minimum length should be 3 characters
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label class="nowrap">Spoc Designation<span class="text-danger">*</span></label>
              <input type="text" (keypress)="textAndSpaceAndDotOnly($event)" autocomplete="off" id="txtSpocDesignation" class="form-control"
                     formControlName="SpocDesignation" trimValue placeholder="Enter Spoc Designation" maxlength="50">
              <div *ngIf="f1['SpocDesignation'].touched && f1['SpocDesignation'].invalid">
                <div *ngIf="f1['SpocDesignation'].errors && f1['SpocDesignation'].errors['required']" class="alert alert-danger required">
                  Spoc Designation is requried
                </div>
                <div *ngIf="f1['SpocDesignation'].errors && f1['SpocDesignation'].errors['minlength']" class="alert alert-danger required">
                  Minimum length should be 3 characters
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label class="nowrap">Spoc Email<span class="text-danger">*</span></label>
              <input type="text" autocomplete="off" id="txtSpocEmail" class="form-control"
                     formControlName="SpocEmail" trimValue placeholder="Enter Spoc Email" maxlength="100">
              <div *ngIf="f1['SpocEmail'].touched && f1['SpocEmail'].invalid">
                <div *ngIf="f1['SpocEmail'].errors && f1['SpocEmail'].errors['required']" class="alert alert-danger required">
                  Spoc Email is requried
                </div>
                <div *ngIf="f1['SpocEmail'].errors && f1['SpocEmail'].errors['minlength']" class="alert alert-danger required">
                  Minimum length should be 3 characters
                </div>
                <div *ngIf="f1['SpocEmail'].errors?.['pattern']" class="alert alert-danger required">
                  Invalid email format
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <label class="nowrap">Spoc Mobile<span class="text-danger">*</span></label>
              <input type="text" (keypress)="numberOnly($event)" autocomplete="off" id="txtSpocMobile" class="form-control"
                     formControlName="SpocMobile" placeholder="Enter Spoc Mobile" maxlength="10">
              <div *ngIf="f1['SpocMobile'].touched && f1['SpocMobile'].invalid">
                <div *ngIf="f1['SpocMobile'].errors && f1['SpocMobile'].errors['required']" class="alert alert-danger required">
                  Spoc Mobile is requried
                </div>
                <div *ngIf="f1['SpocMobile'].errors && f1['SpocMobile'].errors['pattern']" class="alert alert-danger required">
                  Invalid mobile number format
                </div>
              </div>

            </div>

            <div class="col-md-3 mb-3">

              <button id="btnsendotp" type="button" (click)="SendSpocOTP()" [disabled]="(isButtonSpocMobileDisabled || mobileSpocOtpTimerRunning) ||  !(f1['SpocMobile'].value?.length === 10) " class="btn btn-primary btn-sm mb-1 me-2">Send Mobile OTP</button>
              <button id="btnresendotp" type="button" (click)="ReSendSpocMobileOTP()" [disabled]="resendSpocMobileOtpDisabled || mobileSpocOtpTimerRunning || countdown > 0" class="btn btn-primary btn-sm mb-1">
                Resend Mobile OTP
                <span *ngIf="mobileSpocOtpTimerRunning"> {{mobileSpocOtpTimer}}<!--({{ countdownDisplay }})--></span>
              </button>

            </div>
            <div class="col-md-3 mb-3">
              <input type="text" (keypress)="numberOnly($event)" autocomplete="off" id="txtMobOTP" class="form-control" formControlName="spocmobotp"
                     placeholder="Enter OTP sent on your mobile number" maxlength="6" [disabled]="isSpocOTPVerified">
              <div *ngIf="f1['spocmobotp'].touched && f1['spocmobotp'].invalid">
                <!--<div *ngIf="f1['spocmobotp'].errors && f1['spocmobotp'].errors['required']" class="alert alert-danger required">
                  Enter otp sent to your mobile
                </div>-->
                <div *ngIf="f1['spocmobotp'].errors && f1['spocmobotp'].errors['minlength']" class="alert alert-danger required">
                  Minimum length should be 6
                </div>
                <div *ngIf="f1['spocmobotp'].errors && f1['spocmobotp'].errors['maxlength']" class="alert alert-danger required">
                  Maximum length should be 6
                </div>
              </div>

            </div>
            <div class="col-md-3 mb-3">
              <button id="btnverifyotp" type="button" (click)="verifySpocMobileOtp()" [disabled]="(isVerifySpocMobileOtpButtonDisabled) || !(f1['spocmobotp'].value?.length === 6)" class="btn btn-success btn-sm">Verify Mobile OTP</button>
            </div>

            <div class="col-md-3 mb-3">
              <button *ngIf="editingIndex !== null" class="btn btn-primary btn-sm" (click)="add()"><i class="bi bi-person-check"></i> Update</button>
              <button *ngIf="editingIndex === null" class="btn btn-primary me-2 btn-sm" (click)="add()"><i class="bi bi-plus-lg"></i> Add</button>
              <button class="btn btn-danger btn-sm" (click)="resetSpocSelection()"><i class="bi bi-arrow-clockwise"></i> {{txtResetCancel}}</button>
            </div>




          </div>
          <div class="mt-2">
            <div *ngIf="spocList.length === 0" style="color: red;">
              At least one SPOC must be added.(Fill in the Spoc deatils and verify the OTP to add)
            </div>

            <div class="table-responsive ">
              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Spoc Name</th>
                    <th>Spoc Designation</th>
                    <th>Spoc Email</th>
                    <th>Spoc Mobile</th>
                    <th *ngIf="!isMssidc">Action</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let record of spocList;let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ record.spocName }}</td>
                    <td>{{ record.spocDesignation }}</td>
                    <td>{{ record.spocEmail }}</td>
                    <td>{{ record.spocMobile }}</td>
                    <td *ngIf="!isMssidc">

                      <button *ngIf="!record.isEdited" (click)="editSpoc(i)" class="btn btn-primary btn-sm me-2">
                        <i class="bi bi-pencil"></i> Edit
                      </button>

                      <button class="btn btn-danger btn-sm" (click)="removeSpoc(i)">
                        <i class="bi bi-trash"></i> Remove
                      </button>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header"><h2>RAMP</h2></div>
        <div class="card-body">
          <div class="row mb-3" *ngIf="!isMssidc">
            <div class="col-md-4">
              <label class="nowrap">Intervention<span class="text-danger">*</span></label>
              <!--<select id="txtIntervention" class="form-control" formControlName="Intervention" (change)="onInterventionChange($event)">
                <option value="" disabled selected>Select Intervention</option>
                <option *ngFor="let type of interventions" [value]="type.interventionId">
                  {{ type.interventionName }}
                </option>
              </select>-->
              <ng-select [items]="interventions"
                         bindLabel="interventionName"
                         bindValue="interventionId"
                         formControlName="Intervention"
                         [searchable]="true"
                         placeholder="--select--"
                         (change)="onInterventionChange($event)" appendTo="body">
              </ng-select>





              <div *ngIf="f1['Intervention'].touched && f1['Intervention'].invalid" class="alert alert-danger">
                <div *ngIf="f1['Intervention'].errors && f1['Intervention'].errors['required']">
                  Select at least 1 intervention
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label class="nowrap">Components<span class="text-danger">*</span></label>
              <!--<select id="txtInterests" class="form-control" formControlName="InterestsId">
                <option value="" disabled selected>Select Component</option>
                <option *ngFor="let type of filteredInterests" [value]="type.interestId">
                  {{ type.interestName }}
                </option>
              </select>-->
              <ng-select [items]="filteredInterests"
                         bindLabel="interestName"
                         bindValue="interestId"
                         formControlName="InterestsId"
                         [searchable]="true"
                         placeholder="--select--"
                         appendTo="body">
              </ng-select>



              <div *ngIf="f1['InterestsId'].touched && f1['InterestsId'].invalid" class="alert alert-danger">
                <div *ngIf="f1['InterestsId'].errors && f1['InterestsId'].errors['required']">
                  Select at least 1 interest
                </div>
              </div>
            </div>
            <div class="col-md-4 mt-4">
              <button class="btn btn-primary btn-sm" (click)="addPair()"><i class="bi bi-plus-lg"></i> Add Pair</button>
            </div>
          </div>

          <div>
            <div *ngIf="selectedPairs.length === 0" style="color: red;">

              At least one pair must be added.
            </div>
            <div class="table-responsive ">
              <table class="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Intervention</th>
                    <th>Component</th>
                    <th *ngIf="!isMssidc">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pair of selectedPairs; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ pair.interventionName }}</td>
                    <td>{{ pair.interestName }}</td>
                    <td *ngIf="!isMssidc">
                      <button (click)="removePair(i)" class="btn btn-danger btn-sm"><i class="bi bi-trash"></i> Remove</button>
                    </td>
                  </tr>

                </tbody>
              </table>

            </div>
          </div>
          <div class="text-center">
            <button id="btnsave" type="button" (click)="EditIA()" class="btn btn-success btn-sm me-2" *ngIf="!isMssidc"><i class="bi bi-person-check"></i> Update Profile</button>
            <!--<button class="btn btn-danger" id="btnBack" type="submit" [routerLink]="'/login'">Cancel</button>-->
          </div>
        </div>
      </div>



    </div>






    <!--<div class="row">
    <div class="col">
      <h1>Interests</h1>
      <div class="table-responsive">-->
    <!-- Show data in table -->
    <!--<table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">Serial number</th>
                <th class="text-center">Interest Name</th>
                <th class="text-center">Intervention Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let interest of usr_object?.list3,let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center">{{ interest.interestName }}</td>
                <td class="text-center">{{ interest.interventionName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h1>Spoc Details</h1>
        <div class="table-responsive">-->
    <!-- Show data in table -->
    <!--<table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">Serial number</th>
                <th class="text-center">Spoc Name</th>
                <th class="text-center">Spoc Designation</th>
                <th class="text-center">Spoc Email</th>
                <th class="text-center">Spoc Mobile</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let interest of usr_object?.list4,let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center">{{ interest.spocName }}</td>
                <td class="text-center">{{ interest.spocDesignation }}</td>
                <td class="text-center">{{ interest.spocEmail }}</td>
                <td class="text-center">{{ interest.spocMobile }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>-->
  </form>


  <div class="orginfodiv">
    <div *ngIf="!IsProfileCompleted">
      <form [formGroup]="form2">

        <!--for firdt time-->
        <div class="card mb-3">
          <div class="card-header">  <h2>Organizational Information</h2></div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="nowrap">Bank Name<span class="text-danger">*</span></label>
                <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="bankName" trimValue id="txtBankName" class="form-control"
                       name="bankName" placeholder="Bank Name">
                <div *ngIf="f['bankName'].touched && f['bankName'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['bankName'].errors && f['bankName'].errors['required']">
                    Organization Name is required
                  </div>
                  <div *ngIf="f['bankName'].errors && f['bankName'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['bankName'].errors && f['bankName'].errors['pattern']">
                    Enter characters only
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label class="nowrap">Account Number<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberOnly($event)" autocomplete="off" formControlName="accountNumber" id="txtAccountNumber" class="form-control"
                       name="accountNumber" placeholder="Account Number" minLength="9" maxlength="18">
                <div *ngIf="f['accountNumber'].touched && f['accountNumber'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['required']">
                    Account Number is required
                  </div>
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['minlength']">
                    Minimum length should be 9 characters
                  </div>
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['maxlength']">
                    Maximum length should be 18 characters
                  </div>
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['pattern']">
                    Enter numbers only
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label class="nowrap">IFSC Code<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="ifscCode" id="txtIFSCCode" class="form-control"
                       name="ifscCode" placeholder="IFSC Code" trimValue>
                <div *ngIf="f['ifscCode'].touched && f['ifscCode'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['ifscCode'].errors && f['ifscCode'].errors['required']">
                    IFSC Code is required
                  </div>
                  <div *ngIf="f['ifscCode'].errors && f['ifscCode'].errors['minlength']">
                    Length should be 11 characters
                  </div>
                  <div *ngIf="f['ifscCode'].errors && f['ifscCode'].errors['pattern']">
                    Enter Alphanumeric characters only.
                    The first four characters should be uppercase letters
                    The fifth character should always be a zero ('0').
                    The last six characters can be either uppercase letters or digits, representing the branch.
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label class="nowrap">CIN</label>
                <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="cin" trimValue id="txtCIN" class="form-control"
                       name="cin" placeholder="CIN">
                <div *ngIf="f['cin'].touched && f['cin'].invalid" class="alert alert-danger required">
                  <!--<div *ngIf="f['cin'].errors && f['cin'].errors['required']">
                    CIN  is required
                  </div>-->
                  <div *ngIf="f['cin'].errors && f['cin'].errors['minlength']">
                    Minimum length should be 21 characters
                  </div>
                  <div *ngIf="f['cin'].errors && f['cin'].errors['pattern']">
                    Enter proper CIN only.
                    First Character (1 letter): Represents the listing status (L for listed, U for unlisted).
                    Next 5 Characters (5 digits): Represents the industry code (as per the ROC).
                    Next 2 Characters (2 digits): Represents the state code where the company is registered (e.g., MH for Maharashtra, DL for Delhi).
                    Next 4 Characters (4 digits): Represents the year of incorporation.
                    Next 3 Characters (3 letters): Represents the type of company (e.g., PLC for Public Limited Company, PTC for Private Limited Company).
                    Last 6 Characters (6 digits): Represents the unique registration number provided by the ROC.
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-3">
                <label class="nowrap">Organisation PAN<span class="text-danger">*</span></label>
                <input type="text"
                       class="form-control"
                       id="organisationPAN"
                       formControlName="organisationPAN"
                       placeholder="Enter PAN"
                       maxlength="10"
                       (input)="onInputPan($event)" />
                <div *ngIf="f['organisationPAN'].touched && f['organisationPAN'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['organisationPAN'].errors && f['organisationPAN'].errors['required']">
                    Organisation PAN  is required
                  </div>
                  <div *ngIf="f['organisationPAN'].errors && f['organisationPAN'].errors['minlength']">
                    Length should be 10 characters
                  </div>
                  <div *ngIf="f['organisationPAN'].errors && f['organisationPAN'].errors['pattern']">
                    Enter proper PAN only
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <!--<div class="form-group">
                  <label for="DateOfIncorporation" class="text-dark">Date Of Incorporation</label>
                  <input type="date" formControlName="dateOfIncorporation" [max]="maxDate" id="txtDateOfIncorporation" name="dateOfIncorporation" placeholder="Date Of Incorporation"
                         class="form-control" />
                  <div *ngIf="f['dateOfIncorporation'].errors && f['dateOfIncorporation'].errors['required']">
                    Date  is required
                  </div>

                </div>-->
                <!--<div class="form-group">
                  <label for="DateOfIncorporation" class="text-dark">Date Of Incorporation</label>
                  <input type="date" formControlName="dateOfIncorporation" [max]="maxDate" id="txtDateOfIncorporation" name="dateOfIncorporation" placeholder="Date Of Incorporation"
                         class="form-control" />
                  <div *ngIf="f['dateOfIncorporation'].errors && f['dateOfIncorporation'].errors['required']">
                    Date  is required
                  </div>

                </div>-->
                <!--commented this part to implement different approch with mat-->
                <!--<div class="form-group">
                  <label for="DateOfIncorporation" class="text-dark">Date Of Incorporation<span class="text-danger">*</span></label>
                  <input type="date" formControlName="dateOfIncorporation" [max]="maxDate" id="txtDateOfIncorporation" name="dateOfIncorporation" placeholder="Date Of Incorporation"
                         class="form-control" />
                  <div *ngIf="f['dateOfIncorporation'].errors && f['dateOfIncorporation'].errors['required']">
                    Date  is required
                  </div>

                </div>-->
                <!--trying this new approach for the mat part-->

                <label for="dateOfIncorporation">Date Of Incorporation<span class="text-danger">*</span></label>

                <input class="form-control dateOfIncorporation" matInput
                       [matDatepicker]="incorporationPicker"
                       placeholder="Date Of Incorporation"
                       formControlName="dateOfIncorporation"
                       [max]="maxDate"
                       (focus)="incorporationPicker.open()"
                       [value]="dateOfIncorporation | date: 'dd/MM/yyyy'"
                       readonly />

                <!--<mat-datepicker-toggle matSuffix [for]="incorporationPicker"></mat-datepicker-toggle>-->
                <mat-datepicker #incorporationPicker></mat-datepicker>

                <!-- Validation error messages -->
                <div *ngIf="f['dateOfIncorporation'].errors && f['dateOfIncorporation'].errors['required']" class="text-danger">
                  Date of Incorporation is required
                </div>



              </div>



              <div class="col-md-3" style="position: relative; z-index: 9999;">
                <label class="nowrap">GST Number<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" autocomplete="off" formControlName="gstNumber" trimValue id="txtGSTNumber" class="form-control"
                       name="gstNumber" placeholder="GST Number" maxlength="15" (input)="panInGstValidator()">
                <div *ngIf="form2.get('gstNumber')?.touched && f['gstNumber'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['gstNumber'].errors && f['gstNumber'].errors['required']">
                    GST Number  is required
                  </div>
                  <div *ngIf="f['gstNumber'].errors && f['gstNumber'].errors['minlength']">
                    Minimum length should be 15 characters.
                  </div>
                  <div *ngIf="f['gstNumber'].errors && f['gstNumber'].errors['pattern']">
                    Enter proper GST number only.
                    First Two Characters (2 digits): Represents the state code as per the Indian Census.For example, 27 for Maharashtra, 10 for Bihar, etc.
                    Next Ten Characters (10 digits): Represents the PAN (Permanent Account Number) of the business entity.
                    Next Character (1 digit): Represents the entity number of the Pan holder
                    Next Character (1 character): Represents the entity type:Z: Default value.
                    Last Character (1 digit): Represents the either number or alphabet
                  </div>
                </div>
                <div *ngIf="panNotInGst" class="alert alert-danger required">
                  PAN should be a part of the GST Number.
                </div>
              </div>

              <div class="col-md-3">
                <label class="nowrap">Person Name<span class="text-danger">*</span></label>
                <input type="text" (keypress)="textAndSpaceOnly($event)" autocomplete="off" formControlName="personName" trimValue id="txtPersonName" class="form-control"
                       name="personName" placeholder="Person Name">
                <div *ngIf="f['personName'].touched && f['personName'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['personName'].errors && f['personName'].errors['required']">
                    Person Name is required
                  </div>
                  <div *ngIf="f['personName'].errors && f['personName'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['personName'].errors && f['personName'].errors['maxlength']">
                    Maximum length should be 25 characters
                  </div>
                  <div *ngIf="f['personName'].errors && f['personName'].errors['pattern']">
                    Enter characters only
                  </div>
                </div>
              </div>


            </div>
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="nowrap">Contact Number(Landline Number)</label>
                <input type="text" (keypress)="numberanddashOnly($event)" autocomplete="off" formControlName="contactNumber" (input)="formatContactNumber($event)" id="txtContactNumber" class="form-control"
                       name="contactNumber" placeholder="Contact Number" maxlength="13">
                <div *ngIf="f['contactNumber'].touched && f['contactNumber'].invalid" class="alert alert-danger required">

                  <div *ngIf="f['contactNumber'].errors?.['pattern']" class="alert alert-danger">
                    Please enter a valid contact number in the format XXX-XXX-XXXX.Maximum length should be 11 digits
                  </div>
                  <div *ngIf="f['contactNumber'].errors && f['contactNumber'].errors['maxlength']" class="alert alert-danger required">
                    Maximum length should be 11 digits
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label class="nowrap">Mobile Number<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberOnly($event)" autocomplete="off" formControlName="mobileNumber" id="txtMobileNumber" class="form-control"
                       name="mobileNumber" placeholder="Mobile Number" maxlength="10">
                <div *ngIf="f['mobileNumber'].touched && f['mobileNumber'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['mobileNumber'].errors && f['mobileNumber'].errors['required']">
                    Mobile Number is required
                  </div>
                  <div *ngIf="f['mobileNumber'].errors && f['mobileNumber'].errors['minlength']">
                    Minimum length should be 10 characters
                  </div>
                  <div *ngIf="f['mobileNumber'].errors && f['mobileNumber'].errors['pattern']">
                    Invalid Number
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label class="nowrap">Email<span class="text-danger">*</span></label>
                <input type="text" autocomplete="off" formControlName="email" trimValue id="txtEmail" class="form-control"
                       name="email" placeholder="Email">
                <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['email'].errors && f['email'].errors['required']">
                    Email is required
                  </div>

                  <div *ngIf="f['email'].errors && f['email'].errors['pattern']">
                    Enter proper email only
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <label class="nowrap">Designation<span class="text-danger">*</span></label>
                <input type="text" (keypress)="textAndSpaceAndDotOnly($event)" autocomplete="off" formControlName="designation" id="txtDesignation" class="form-control"
                       name="designation" placeholder="Designation">
                <div *ngIf="f['designation'].touched && f['designation'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['designation'].errors && f['designation'].errors['required']">
                    Designation is required
                  </div>

                  <div *ngIf="f['designation'].errors && f['designation'].errors['pattern']">
                    Enter characters only
                  </div>
                  <div *ngIf="f['designation'].errors && f['designation'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['designation'].errors && f['designation'].errors['maxlength']">
                    Maximum length should be 25 characters
                  </div>
                </div>
              </div>


            </div>
            <div class="row mb-3">
              <div class="col-md-3">
                <div class="form-group mb-2 w-100">
                  <label class="mb-2">
                    IA Logo Image Upload<span class="text-danger">*</span><br>
                    <small class="text-muted">(JPEG, JPG, PNG - File size should be less than 2MB)</small>
                    <small class="text-muted">(Width and Height of Image should be within 200 * 200)</small>
                  </label>

                  <input class="form-control" type="file" (change)="onIALogoFileSelected($event)" formControlName="ialogoFile" />


                  <!-- Image Preview from URL -->

                  <div *ngIf="ialogoUrl" class="image-preview mb-2">
                    <img [src]="ialogoUrl" alt="IA Logo Image" class="img-thumbnail" width="200" height="200" />
                  </div>
                  <!--<div class="image-preview mb-2">
                    <img [src]="bookForm.get('frontBookImagePath')?.value" alt="Front Book Image" class="img-thumbnail" width="150" height="150" />
                  </div>-->
                  <label class="mb-2">{{ form2.get('iaLogoName')?.value }}</label>



                  <div *ngIf="form2.get('iaLogoName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                    Logo File Upload is required.
                  </div>
                  <div *ngIf="IalogoErrors?.typeError" class="alert alert-danger required">
                    Invalid logo file type. Only images (jpeg, jpg, png) are allowed.
                  </div>
                  <div *ngIf="IalogoErrors?.sizeError" class="alert alert-danger required">
                    Logo File size exceeds the 2MB limit.
                  </div>
                  <div *ngIf="IalogoErrors?.dimensionError" class="alert alert-danger required">
                    Logo Image dimensions must be within 200x200 pixels.
                  </div>

                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-2 w-100">
                  <label class="mb-2">
                    IA Signature Image Upload<span class="text-danger">*</span><br>
                    <small class="text-muted">(JPEG, JPG, PNG - File size should be less than 2MB)</small>
                    <small class="text-muted">(Width and Height of Image should be within 200 * 200)</small>
                  </label>

                  <input class="form-control" type="file" (change)="onIASigFileSelected($event)" formControlName="iasigFile" />


                  <!-- Image Preview from URL -->

                  <div *ngIf="iasigUrl" class="image-preview mb-2">
                    <img [src]="iasigUrl" alt="IA Sig Image" class="img-thumbnail" width="200" height="200" />
                  </div>
                  <!--<div class="image-preview mb-2">
                    <img [src]="bookForm.get('frontBookImagePath')?.value" alt="Front Book Image" class="img-thumbnail" width="150" height="150" />
                  </div>-->
                  <label class="mb-2">{{ form2.get('iaSigName')?.value }}</label>



                  <div *ngIf="form2.get('iaSigName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                    Signature File Upload is required.
                  </div>
                  <div *ngIf="IasigErrors?.typeError" class="alert alert-danger required">
                    Invalid signature file type. Only images (jpeg, jpg, png) are allowed.
                  </div>
                  <div *ngIf="IasigErrors?.sizeError" class="alert alert-danger required">
                    Signature File size exceeds the 2MB limit.
                  </div>
                  <div *ngIf="IasigErrors?.dimensionError" class="alert alert-danger required">
                    Signature Image dimensions must be within 200x200 pixels.
                  </div>

                </div>
              </div>

              <div class="col-md-3">
                <label class="nowrap">Which type of GST is applicable?<span class="text-danger">*</span><br></label><br>

                <!-- Radio Buttons -->
                <input type="radio" name="gstType" id="cgstsgst" value="CGSTSGST" formControlName="gstType" (click)="showTextBox()">
                <label for="cgst">CGST/SGST</label><br>

                <input type="radio" name="gstType" id="igst" value="IGST" formControlName="gstType" (click)="showTextBox()">
                <label for="sgst">IGST</label><br>

                <div *ngIf="form2.get('gstType')?.touched && form2.get('gstType')?.errors?.['required']" class="alert alert-danger required">
                  GST Type is required.
                </div>


                <!-- Label for GST Percentage (Initially Hidden) -->
                <label id="gstLabel" style="display: none; font-weight: bold;">GST Percent</label>

                <!-- Text Box (Initially Hidden) -->
                <input type="text" id="gstPercent" (keypress)="gstnumberOnly($event)" maxlength="2" formControlName="gstPercent" class="form-control mt-2" placeholder="Enter GST percent" style="display: none;">
                <!--<div *ngIf="form2.get('gstPercent')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                  GST percent is required.
                </div>-->
                <div *ngIf="form2.get('gstPercent')?.touched && f['gstPercent'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['gstPercent'].errors && f['gstPercent'].errors['required']">
                    GST percent is required
                  </div>
                </div>




              </div>


            </div>



            <div class="row mb-3">

              <div class="col-md-9">
                <label class="text-dark">Brief Background Of IA<span class="text-danger">*</span></label>
                <textarea type="text" class="form-control" formControlName="briefBackgroundIA" trimValue></textarea>
                <!-- Character count display -->
                <!--<small class="text-muted">
                  {{ f['briefBackgroundIA'].value?.length || 0 }}/5000 characters
                </small>-->
                <div *ngIf="f['briefBackgroundIA'].touched && f['briefBackgroundIA'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['required']">
                    Brief Background Of IA is required
                  </div>

                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['pattern']">
                    Enter characters only
                  </div>
                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['maxlength']">
                    Maximum length should be 5000 characters
                  </div>
                </div>

              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-9">
                <label class="text-dark">Summary and Scale Of Projects<span class="text-danger">*</span></label>
                <textarea type="text" class="form-control" formControlName="summaryScaleIA" trimValue></textarea>
                <!-- Character count display -->
                <!--<small class="text-muted">
                  {{ f['summaryScaleIA'].value?.length || 0 }}/5000 characters
                </small>-->
                <div *ngIf="f['summaryScaleIA'].touched && f['summaryScaleIA'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['required']">
                    Summary and Scale Of Projects is required
                  </div>

                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['pattern']">
                    Enter characters only
                  </div>
                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['maxlength']">
                    Maximum length should be 5000 characters
                  </div>
                </div>

              </div>
            </div>



            <div class="text-center">
              <!--<button id="btnsave" type="button" (click)="Save(form2)" class="btn btn-success">Save</button>&nbsp;&nbsp;-->
              <button id="btnsave" type="button" (click)="onSubmit()" class="btn btn-success me-2" *ngIf="!isMssidc"><i class="bi bi-save"></i> Save Organizational Information</button>
              <button id="btncancel" type="reset" (click)="onReset()" class="btn btn-danger" *ngIf="!isMssidc"><i class="bi bi-x-circle"></i> Cancel</button>
            </div>
          </div>
        </div>

      </form>
    </div>
    <div *ngIf="IsProfileCompleted">
      <form [formGroup]="form2">
        <!--for update-->
        <div class="card mb-3">
          <div class="card-header"> <h2>Organizational Information</h2></div>
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="text-dark">Bank Name<span class="text-danger">*</span></label>
                <input type="text" (keypress)="textAndSpaceOnly($event)" class="form-control" formControlName="bankName" trimValue>
                <div *ngIf="f['bankName'].touched && f['bankName'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['bankName'].errors && f['bankName'].errors['required']">
                    Organization Name is required
                  </div>
                  <div *ngIf="f['bankName'].errors && f['bankName'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['bankName'].errors && f['bankName'].errors['pattern']">
                    Enter characters only
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label class="text-dark">Account Number<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="accountNumber" maxlength="18">
                <div *ngIf="f['accountNumber'].touched && f['accountNumber'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['required']">
                    Account Number is required
                  </div>
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['minlength']">
                    Minimum length should be 9 characters
                  </div>
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['maxlength']">
                    Maximum length should be 18 characters
                  </div>
                  <div *ngIf="f['accountNumber'].errors && f['accountNumber'].errors['pattern']">
                    Enter numbers only
                  </div>
                </div>

              </div>
              <div class="col-md-3">
                <label class="text-dark">IFSC Code<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="ifscCode" trimValue>
                <div *ngIf="f['ifscCode'].touched && f['ifscCode'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['ifscCode'].errors && f['ifscCode'].errors['required']">
                    IFSC Code is required
                  </div>
                  <div *ngIf="f['ifscCode'].errors && f['ifscCode'].errors['minlength']">
                    Length should be 11 characters
                  </div>
                  <div *ngIf="f['ifscCode'].errors && f['ifscCode'].errors['pattern']">
                    Enter Alphanumeric characters only.
                    The first four characters should be uppercase letters
                    The fifth character should always be a zero ('0').
                    The last six characters can be either uppercase letters or digits, representing the branch.
                  </div>
                </div>

              </div>
              <div class="col-md-3">
                <label class="text-dark">CIN</label>
                <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="cin" trimValue>
                <div *ngIf="f['cin'].touched && f['cin'].invalid" class="alert alert-danger required">
                  <!--<div *ngIf="f['cin'].errors && f['cin'].errors['required']">
                    CIN  is required
                  </div>-->
                  <div *ngIf="f['cin'].errors && f['cin'].errors['minlength']">
                    Minimum length should be 21 characters
                  </div>
                  <div *ngIf="f['cin'].errors && f['cin'].errors['pattern']">
                    Enter proper CIN only.
                    First Character (1 letter): Represents the listing status (L for listed, U for unlisted).
                    Next 5 Characters (5 digits): Represents the industry code (as per the ROC).
                    Next 2 Characters (2 digits): Represents the state code where the company is registered (e.g., MH for Maharashtra, DL for Delhi).
                    Next 4 Characters (4 digits): Represents the year of incorporation.
                    Next 3 Characters (3 letters): Represents the type of company (e.g., PLC for Public Limited Company, PTC for Private Limited Company).
                    Last 6 Characters (6 digits): Represents the unique registration number provided by the ROC.
                  </div>
                </div>

              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-3">
                <label class="text-dark">Organisation PAN<span class="text-danger">*</span></label>
                <!--<input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="organisationPAN" trimValue maxlength="10">-->
                <input type="text"
                       class="form-control"
                       id="organisationPAN"
                       formControlName="organisationPAN"
                       placeholder="Enter PAN"
                       maxlength="10"
                       (input)="onInputPan($event)" />
                <div *ngIf="f['organisationPAN'].touched && f['organisationPAN'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['organisationPAN'].errors && f['organisationPAN'].errors['required']">
                    Organisation PAN  is required
                  </div>
                  <div *ngIf="f['organisationPAN'].errors && f['organisationPAN'].errors['minlength']">
                    Length should be 10 characters
                  </div>
                  <div *ngIf="f['organisationPAN'].errors && f['organisationPAN'].errors['pattern']">
                    Enter proper PAN only
                  </div>
                </div>


              </div>
              <!--<div class="col-md-3">
                <div class="form-group">
                  <label class="text-dark">Date Of Incorporation<span class="text-danger">*</span></label>
                  <input type="text" class="form-control" formControlName="dateOfIncorporation" />
                  <div *ngIf="f['dateOfIncorporation'].errors && f['dateOfIncorporation'].errors['required']">
                    Date  is required
                  </div>

                </div>
              </div>-->
              <div class="col-md-3">
                <label for="dateOfIncorporation">Date Of Incorporation<span class="text-danger">*</span></label>

                <input class="form-control dateOfIncorporation" matInput
                       [matDatepicker]="incorporationPicker"
                       placeholder="Date Of Incorporation"
                       formControlName="dateOfIncorporation"
                       [max]="maxDate"
                       (focus)="incorporationPicker.open()"
                       [value]="dateOfIncorporation | date: 'dd/MM/yyyy'"
                       readonly />

                <!--<mat-datepicker-toggle matSuffix [for]="incorporationPicker"></mat-datepicker-toggle>-->
                <mat-datepicker #incorporationPicker></mat-datepicker>

                <!-- Validation error messages -->
                <div *ngIf="f['dateOfIncorporation'].errors && f['dateOfIncorporation'].errors['required']" class="text-danger">
                  Date of Incorporation is required
                </div>
              </div>






              <div class="col-md-3">
                <label class="text-dark">GST Number<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberAndCapitalAlphabetsOnly($event)" class="form-control" formControlName="gstNumber" trimValue maxlength="15" (input)="panInGstValidator()">
                <div *ngIf="form2.get('gstNumber')?.touched && f['gstNumber'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['gstNumber'].errors && f['gstNumber'].errors['required']">
                    GST Number  is required
                  </div>
                  <div *ngIf="f['gstNumber'].errors && f['gstNumber'].errors['minlength']">
                    Minimum length should be 15 characters.
                  </div>
                  <div *ngIf="f['gstNumber'].errors && f['gstNumber'].errors['pattern']">
                    Enter proper GST number only.
                    First Two Characters (2 digits): Represents the state code as per the Indian Census.For example, 27 for Maharashtra, 10 for Bihar, etc.
                    Next Ten Characters (10 digits): Represents the PAN (Permanent Account Number) of the business entity.
                    Next Character (1 digit): Represents the entity number of the Pan holder
                    Next Character (1 character): Represents the entity type:Z: Default value.
                    Last Character (1 digit): Represents the either number or alphabet
                  </div>
                </div>
                <div *ngIf="panNotInGst" class="alert alert-danger required">
                  PAN should be a part of the GST Number.
                </div>
              </div>
              <div class="col-md-3">
                <label class="text-dark">Person Name<span class="text-danger">*</span></label>
                <input type="text" (keypress)="textAndSpaceOnly($event)" class="form-control" formControlName="personName" trimValue>
                <div *ngIf="f['personName'].touched && f['personName'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['personName'].errors && f['personName'].errors['required']">
                    Person Name is required
                  </div>
                  <div *ngIf="f['personName'].errors && f['personName'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['personName'].errors && f['personName'].errors['maxlength']">
                    Maximum length should be 25 characters
                  </div>
                  <div *ngIf="f['personName'].errors && f['personName'].errors['pattern']">
                    Enter characters only
                  </div>
                </div>

              </div>


            </div>
            <div class="row mb-3">
              <div class="col-md-3">
                <label class="text-dark">Contact Number(Landline Number)</label>
                <input type="text" (keypress)="numberanddashOnly($event)" class="form-control" formControlName="contactNumber" (input)="formatContactNumber($event)" maxlength="13">
                <div *ngIf="f['contactNumber'].touched && f['contactNumber'].invalid" class="alert alert-danger required">


                  <div *ngIf="f['contactNumber'].errors?.['pattern']" class="alert alert-danger">
                    Please enter a valid contact number in the format XXX-XXX-XXXX.Maximum length should be 11 digits
                  </div>
                  <div *ngIf="f['contactNumber'].errors && f['contactNumber'].errors['maxlength']" class="alert alert-danger required">
                    Maximum length should be 11 digits
                  </div>
                </div>

              </div>
              <div class="col-md-3">
                <label class="text-dark">Mobile Number<span class="text-danger">*</span></label>
                <input type="text" (keypress)="numberOnly($event)" class="form-control" formControlName="mobileNumber" maxlength="10">
                <div *ngIf="f['mobileNumber'].touched && f['mobileNumber'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['mobileNumber'].errors && f['mobileNumber'].errors['required']">
                    Mobile Number is required
                  </div>
                  <div *ngIf="f['mobileNumber'].errors && f['mobileNumber'].errors['minlength']">
                    Minimum length should be 10 characters
                  </div>
                  <div *ngIf="f['mobileNumber'].errors && f['mobileNumber'].errors['pattern']">
                    Enter numbers only
                  </div>
                </div>

              </div>
              <div class="col-md-3">
                <label class="text-dark">Email<span class="text-danger">*</span></label>
                <input type="text" class="form-control" formControlName="email" trimValue>
                <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['email'].errors && f['email'].errors['required']">
                    Email is required
                  </div>

                  <div *ngIf="f['email'].errors && f['email'].errors['pattern']">
                    Enter proper email only
                  </div>
                </div>

              </div>
              <div class="col-md-3">
                <label class="text-dark">Designation<span class="text-danger">*</span></label>
                <input type="text" (keypress)="textAndSpaceAndDotOnly($event)" class="form-control" formControlName="designation">
                <div *ngIf="f['designation'].touched && f['designation'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['designation'].errors && f['designation'].errors['required']">
                    Designation is required
                  </div>

                  <div *ngIf="f['designation'].errors && f['designation'].errors['pattern']">
                    Enter characters only
                  </div>
                  <div *ngIf="f['designation'].errors && f['designation'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['designation'].errors && f['designation'].errors['maxlength']">
                    Maximum length should be 25 characters
                  </div>
                </div>

              </div>


            </div>
            <div class="row mb-3">
              <div class="col-md-3">
                <div class="form-group mb-2 w-100">
                  <label class="mb-2">
                    IA Logo Image Upload<span class="text-danger">*</span><br>
                    <small class="text-muted">(JPEG, JPG, PNG - File size should be less than 2MB)</small>
                    <small class="text-muted">(Width and Height of Image should be within 200 * 200)</small>
                  </label>


                  <!--<input class="form-control" type="file" (change)="onIALogoFileSelected($event)" formControlName="ialogoFile" />-->

                  <div class="custom-file" *ngIf="!isMssidc">
                    <input type="file" id="ialogoFile" (change)="onIALogoFileSelected($event)" formControlName="ialogoFile" hidden />
                    <label for="ialogoFile" class="btn btn-primary">
                      Choose File
                    </label>
                    <span *ngIf="form2.get('iaLogoName')?.value">{{ form2.get('iaLogoName')?.value }}</span>
                  </div>


                  <!-- Image Preview from URL -->

                  <div *ngIf="ialogoUrl" class="image-preview mb-2">
                    <img [src]="ialogoUrl" alt="IA Logo Image" class="img-thumbnail" width="200" height="200" />
                  </div>
                  <!--<div class="image-preview mb-2">
                    <img [src]="bookForm.get('frontBookImagePath')?.value" alt="Front Book Image" class="img-thumbnail" width="150" height="150" />
                  </div>-->
                  <label class="mb-2">{{ form2.get('iaLogoName')?.value }}</label>



                  <div *ngIf="form2.get('iaLogoName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                    Logo File Upload is required.
                  </div>
                  <div *ngIf="IalogoErrors?.typeError" class="alert alert-danger required">
                    Invalid logo file type. Only images (jpeg, jpg, png) are allowed.
                  </div>
                  <div *ngIf="IalogoErrors?.sizeError" class="alert alert-danger required">
                    Logo File size exceeds the 2MB limit.
                  </div>
                  <div *ngIf="IalogoErrors?.dimensionError" class="alert alert-danger required">
                    Logo Image dimensions must be within 200x200 pixels.
                  </div>

                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-2 w-100">
                  <label class="mb-2">
                    IA Signature Image Upload<span class="text-danger">*</span><br>
                    <small class="text-muted">(JPEG, JPG, PNG - File size should be less than 2MB)</small>
                    <small class="text-muted">(Width and Height of Image should be within 200 * 200)</small>
                  </label>


                  <!--<input class="form-control" type="file" (change)="onIALogoFileSelected($event)" formControlName="ialogoFile" />-->

                  <div class="custom-file" *ngIf="!isMssidc">
                    <input type="file" id="iasigFile" (change)="onIASigFileSelected($event)" formControlName="iasigFile" hidden />
                    <label for="iasigFile" class="btn btn-primary">
                      Choose File
                    </label>
                    <span *ngIf="form2.get('iaSigName')?.value">{{ form2.get('iaSigName')?.value }}</span>
                  </div>


                  <!-- Image Preview from URL -->

                  <div *ngIf="iasigUrl" class="image-preview mb-2">
                    <img [src]="iasigUrl" alt="IA Sig Image" class="img-thumbnail" width="200" height="200" />
                  </div>
                  <!--<div class="image-preview mb-2">
                    <img [src]="bookForm.get('frontBookImagePath')?.value" alt="Front Book Image" class="img-thumbnail" width="150" height="150" />
                  </div>-->
                  <label class="mb-2">{{ form2.get('iaSigName')?.value }}</label>



                  <div *ngIf="form2.get('iaSigName')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                    Signature File Upload is required.
                  </div>
                  <div *ngIf="IasigErrors?.typeError" class="alert alert-danger required">
                    Invalid signature file type. Only images (jpeg, jpg, png) are allowed.
                  </div>
                  <div *ngIf="IasigErrors?.sizeError" class="alert alert-danger required">
                    Signature File size exceeds the 2MB limit.
                  </div>
                  <div *ngIf="IasigErrors?.dimensionError" class="alert alert-danger required">
                    Signature Image dimensions must be within 200x200 pixels.
                  </div>

                </div>
              </div>
              <div class="col-md-3">
                <label class="nowrap">Which type of GST is applicable?<span class="text-danger">*</span><br></label><br>

                <!-- Radio Buttons -->
                <input type="radio" name="gstType" id="cgstsgst" value="CGSTSGST" formControlName="gstType" (click)="blankTextBox()">
                <label for="cgst">CGST/SGST</label><br>

                <input type="radio" name="gstType" id="igst" value="IGST" formControlName="gstType" (click)="blankTextBox()">
                <label for="sgst">IGST</label><br>

                <div *ngIf="form2.get('gstType')?.touched && form2.get('gstType')?.errors?.['required']" class="alert alert-danger required">
                  GST Type is required.
                </div>


                <!-- Label for GST Percentage (Initially Hidden) -->
                <label id="gstLabel" style="font-weight: bold;">GST Percent</label>

                <!-- Text Box (Initially Hidden) -->
                <input type="text" id="gstPercent" (keypress)="gstnumberOnly($event)" maxlength="2" formControlName="gstPercent" class="form-control mt-2" placeholder="Enter GST percent">
                <!--<div *ngIf="form2.get('gstPercent')?.errors?.['required'] && isSubmitted" class="alert alert-danger required">
                  GST percent is required.
                </div>-->
                <div *ngIf="form2.get('gstPercent')?.touched && f['gstPercent'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['gstPercent'].errors && f['gstPercent'].errors['required']">
                    GST percent is required
                  </div>
                </div>

              </div>

            </div>



            <div class="row mb-3">
              <div class="col-md-9">
                <label class="text-dark">Brief Background Of IA<span class="text-danger">*</span></label>
                <textarea type="text" class="form-control" formControlName="briefBackgroundIA" trimValue> </textarea>
                <!-- Character count display -->
                <!--<small class="text-muted">
                  {{ f['briefBackgroundIA'].value?.length || 0 }}/5000 characters
                </small>-->
                <div *ngIf="f['briefBackgroundIA'].touched && f['briefBackgroundIA'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['required']">
                    Brief Background Of IA is required
                  </div>

                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['pattern']">
                    Enter characters only
                  </div>
                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['briefBackgroundIA'].errors && f['briefBackgroundIA'].errors['maxlength']">
                    Maximum length should be 5000 characters
                  </div>
                </div>

              </div>

            </div>
            <div class="row mb-3">
              <div class="col-md-9">
                <label class="text-dark">Summary and Scale Of Projects<span class="text-danger">*</span></label>
                <textarea type="text" class="form-control" formControlName="summaryScaleIA" trimValue></textarea>
                <!-- Character count display -->
                <!--<small class="text-muted">
                  {{ f['summaryScaleIA'].value?.length || 0 }}/5000 characters
                </small>-->
                <div *ngIf="f['summaryScaleIA'].touched && f['summaryScaleIA'].invalid" class="alert alert-danger required">
                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['required']">
                    Summary and Scale Of Projects is required
                  </div>

                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['pattern']">
                    Enter characters only
                  </div>
                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['minlength']">
                    Minimum length should be 3 characters
                  </div>
                  <div *ngIf="f['summaryScaleIA'].errors && f['summaryScaleIA'].errors['maxlength']">
                    Maximum length should be 5000 characters
                  </div>
                </div>

              </div>
            </div>
            <!--@if(!isEditable)
            {
            <div class="text-center">
              <button type="button" (click)="toggleEdit()" class="btn btn-primary">Edit</button>

            </div>
            }
            @else{-->
            <button type="button" (click)="updateEdit()" class="btn btn-primary" *ngIf="!isMssidc"> <i class="bi bi-person-check"></i> Update Organizational Information</button>
            <!--}-->
            <!--<pre>{{form2.value|json}}</pre>-->


          </div>
        </div>



      </form>
    </div>
  </div>
</div>

